(() => {
  'use strict';

  /* PN_MANUAL_UPI_BATCH_PAYOUT_V1 */
  /* PN_MANUAL_UPI_DESKTOP_FIX_V1 */

  let activeMentorId =
    null;

  let pendingOpen =
    false;


  const esc = value =>
    String(
      value ??
      ''
    )
      .replaceAll(
        '&',
        '&amp;'
      )
      .replaceAll(
        '<',
        '&lt;'
      )
      .replaceAll(
        '>',
        '&gt;'
      )
      .replaceAll(
        '"',
        '&quot;'
      )
      .replaceAll(
        "'",
        '&#039;'
      );


  function money(
    value,
    currency = 'INR'
  ) {

    return new Intl
      .NumberFormat(
        'en-IN',
        {
          style:
            'currency',

          currency:
            currency ||
            'INR',

          maximumFractionDigits:
            2
        }
      )
      .format(
        Number(
          value ||
          0
        )
      );

  }


  function dateText(
    value
  ) {

    if (!value) {
      return '—';
    }


    const date =
      new Date(value);


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return '—';
    }


    return date
      .toLocaleString();

  }


  async function rpc(
    name,
    body = {}
  ) {

    return window.PeerNestDB
      .request(
        `rpc/${name}`,
        '',
        {
          method:
            'POST',

          body
        }
      );

  }


  function closeManual() {

    document
      .querySelector(
        '[data-pnm-payout-modal]'
      )
      ?.remove();

  }


  function hideLegacyRazorpayX() {

    document
      .querySelectorAll(
        '.pn5-payout-head'
      )
      .forEach(
        head => {

          const text =
            String(
              head.textContent ||
              ''
            )
              .toUpperCase();


          if (
            !text.includes(
              'RAZORPAYX'
            )
          ) {
            return;
          }


          const root =
            head.parentElement;


          if (root) {

            root.hidden =
              true;

            root.dataset
              .pnLegacyPayoutHidden =
              'true';

          }

        }
      );

  }


  async function copyText(
    text
  ) {

    try {

      await navigator
        .clipboard
        .writeText(
          String(
            text ||
            ''
          )
        );

      return true;

    }
    catch (_) {

      return false;

    }

  }


  function historyTable(
    rows
  ) {

    if (!rows.length) {

      return `
        <div class="pnm-empty">
          No previous payout batches.
        </div>
      `;

    }


    return `
      <div class="pnm-table-wrap">

        <table class="pnm-table">

          <thead>
            <tr>
              <th>Date</th>
              <th>Amount</th>
              <th>Sessions</th>
              <th>Status</th>
              <th>UTR</th>
            </tr>
          </thead>

          <tbody>

            ${rows
              .map(
                row => `
                  <tr>

                    <td>
                      ${esc(
                        dateText(
                          row.processed_at ||
                          row.created_at
                        )
                      )}
                    </td>

                    <td>
                      <strong>
                        ${money(
                          row.amount,
                          row.currency
                        )}
                      </strong>
                    </td>

                    <td>
                      ${esc(
                        row.earning_count ||
                        0
                      )}
                    </td>

                    <td>
                      <span
                        class="pnm-status"
                        data-state="${esc(
                          String(
                            row.status ||
                            ''
                          )
                            .toLowerCase()
                        )}"
                      >
                        ${esc(
                          String(
                            row.status ||
                            'unknown'
                          )
                        )}
                      </span>
                    </td>

                    <td>
                      ${esc(
                        row.provider_utr ||
                        '—'
                      )}
                    </td>

                  </tr>
                `
              )
              .join('')}

          </tbody>

        </table>

      </div>
    `;

  }


  async function getData(
    mentorId
  ) {

    const [
      context,
      payouts
    ] =
      await Promise.all([

        rpc(
          'admin_get_mentor_manual_payout_context_v1',
          {
            p_mentor_id:
              mentorId
          }
        ),

        rpc(
          'admin_list_mentor_payouts_v1'
        )

      ]);


    return {

      context,

      payouts:
        Array.isArray(
          payouts
        )
          ? payouts.filter(
              row =>
                String(
                  row.mentor_id
                ) ===
                String(
                  mentorId
                )
            )
          : []

    };

  }


  async function render(
    panel,
    mentorId,
    message = ''
  ) {

    panel.innerHTML = `
      <div class="pnm-loading">
        Loading payout…
      </div>
    `;


    try {

      const {
        context,
        payouts
      } =
        await getData(
          mentorId
        );


      const batch =
        context
          ?.open_payout ||
        null;


      const amount =
        Number(
          batch?.amount ||
          0
        );


      const upi =
        String(
          context
            ?.upi_id ||
          ''
        );


      const currency =
        context
          ?.currency ||
        'INR';


      const upiLink =
        batch &&
        upi
          ? (
              `upi://pay?pa=${
                encodeURIComponent(
                  upi
                )
              }&pn=${
                encodeURIComponent(
                  context
                    ?.mentor_name ||
                  'PeerNest Mentor'
                )
              }&am=${
                encodeURIComponent(
                  amount.toFixed(2)
                )
              }&cu=INR&tn=${
                encodeURIComponent(
                  'PeerNest mentor payout'
                )
              }`
            )
          : '#';


      const mobileUpi =
        /Android|iPhone|iPad|iPod/i
          .test(
            navigator.userAgent
          );


      panel.innerHTML = `

        <div class="pnm-head">

          <div>

            <span>
              MENTOR SETTLEMENT
            </span>

            <h2>
              ${esc(
                context
                  ?.mentor_name ||
                'PeerNest Mentor'
              )}
            </h2>

            <p>
              ${esc(
                context
                  ?.mentor_email ||
                ''
              )}
            </p>

          </div>


          <button
            type="button"
            class="pnm-close"
            data-pnm-close
          >
            ×
          </button>

        </div>


        ${
          message
            ? `
              <div class="pnm-message">
                ${esc(message)}
              </div>
            `
            : ''
        }


        <div class="pnm-summary">

          <article>
            <span>
              AVAILABLE EARNINGS
            </span>

            <strong>
              ${money(
                context
                  ?.available_total,
                currency
              )}
            </strong>
          </article>


          <article>
            <span>
              CURRENTLY RESERVED
            </span>

            <strong>
              ${money(
                context
                  ?.reserved_total,
                currency
              )}
            </strong>
          </article>


          <article>
            <span>
              NEXT BATCH
            </span>

            <strong>
              ${money(
                context
                  ?.unbatched_total,
                currency
              )}
            </strong>
          </article>

        </div>


        <section class="pnm-section">

          <div class="pnm-section-head">

            <div>
              <span>
                PAYOUT DESTINATION
              </span>

              <h3>
                UPI
              </h3>
            </div>


            <span
              class="pnm-ready ${
                context?.ready
                  ? 'is-ready'
                  : ''
              }"
            >
              ${
                context?.ready
                  ? 'Ready'
                  : 'Not configured'
              }
            </span>

          </div>


          ${
            context?.ready
              ? `
                <div class="pnm-upi">

                  <div>
                    <small>
                      Mentor UPI
                    </small>

                    <strong>
                      ${esc(
                        context
                          .masked_upi ||
                        upi
                      )}
                    </strong>
                  </div>


                  <button
                    type="button"
                    data-pnm-copy="${esc(
                      upi
                    )}"
                  >
                    Copy UPI
                  </button>

                </div>
              `
              : `
                <div class="pnm-empty">
                  This mentor has not added a UPI ID yet.
                </div>
              `
          }

        </section>


        <section class="pnm-section">

          <div class="pnm-section-head">

            <div>
              <span>
                CURRENT PAYOUT
              </span>

              <h3>
                ${
                  batch
                    ? 'Batch ready to settle'
                    : 'No active batch'
                }
              </h3>
            </div>

          </div>


          ${
            batch
              ? `

                <div class="pnm-batch">

                  <div class="pnm-batch-main">

                    <small>
                      PAY THIS AMOUNT
                    </small>

                    <strong>
                      ${money(
                        batch.amount,
                        batch.currency
                      )}
                    </strong>

                    <p>
                      ${esc(
                        batch.earning_count ||
                        0
                      )}
                      completed session${
                        Number(
                          batch.earning_count ||
                          0
                        ) === 1
                          ? ''
                          : 's'
                      }
                      included.
                    </p>

                  </div>


                  <div class="pnm-actions">

                    <button
                      type="button"
                      data-pnm-copy="${esc(
                        amount.toFixed(2)
                      )}"
                    >
                      Copy amount
                    </button>


                    ${
                      mobileUpi
                        ? `
                          <a
                            href="${esc(
                              upiLink
                            )}"
                            class="pnm-primary"
                          >
                            Open UPI app
                          </a>
                        `
                        : `
                          <button
                            type="button"
                            class="pnm-primary"
                            data-pnm-copy="${esc(
                              upi
                            )}"
                          >
                            Copy UPI for phone
                          </button>
                        `
                    }

                  </div>

                </div>


                <div class="pnm-confirm">

                  <label>

                    <span>
                      UTR / Transaction ID
                    </span>

                    <input
                      type="text"
                      autocomplete="off"
                      placeholder="Enter after completing the UPI transfer"
                      data-pnm-utr
                    >

                  </label>


                  <div class="pnm-confirm-actions">

                    <button
                      type="button"
                      class="pnm-danger"
                      data-pnm-cancel="${esc(
                        batch.id
                      )}"
                    >
                      Cancel batch
                    </button>


                    <button
                      type="button"
                      class="pnm-primary"
                      data-pnm-confirm="${esc(
                        batch.id
                      )}"
                      data-pnm-amount="${esc(
                        batch.amount
                      )}"
                    >
                      Confirm payout
                    </button>

                  </div>


                  <small class="pnm-warning">
                    Confirm only after the money has actually
                    been transferred to the mentor.
                  </small>

                </div>

              `
              : (
                  context?.ready &&
                  Number(
                    context
                      ?.unbatched_total ||
                    0
                  ) > 0

                    ? `
                      <div class="pnm-create">

                        <div>

                          <small>
                            READY FOR NEXT BATCH
                          </small>

                          <strong>
                            ${money(
                              context
                                .unbatched_total,
                              currency
                            )}
                          </strong>

                          <p>
                            This will reserve all currently
                            payable completed earnings.
                          </p>

                        </div>


                        <button
                          type="button"
                          class="pnm-primary"
                          data-pnm-create="${esc(
                            mentorId
                          )}"
                        >
                          Create payout batch
                        </button>

                      </div>
                    `

                    : `
                      <div class="pnm-empty">
                        No new mentor earnings are ready
                        for settlement.
                      </div>
                    `
                )
          }

        </section>


        <section class="pnm-section">

          <div class="pnm-section-head">

            <div>
              <span>
                HISTORY
              </span>

              <h3>
                Payout batches
              </h3>
            </div>

          </div>


          ${historyTable(
            payouts
          )}

        </section>

      `;


    }
    catch (error) {

      panel.innerHTML = `

        <div class="pnm-head">

          <div>
            <span>
              MENTOR SETTLEMENT
            </span>

            <h2>
              Could not load payout
            </h2>
          </div>


          <button
            type="button"
            class="pnm-close"
            data-pnm-close
          >
            ×
          </button>

        </div>


        <div class="pnm-error">
          ${esc(
            error?.message ||
            'Unknown payout error'
          )}
        </div>

      `;

    }

  }


  async function openManual(
    mentorId
  ) {

    if (!mentorId) {
      return;
    }


    closeManual();

    hideLegacyRazorpayX();


    const modal =
      document.createElement(
        'div'
      );


    modal.className =
      'pnm-modal';

    modal.setAttribute(
      'data-pnm-payout-modal',
      ''
    );


    modal.innerHTML = `

      <div
        class="pnm-backdrop"
        data-pnm-close
      ></div>


      <aside class="pnm-panel">

        <div class="pnm-loading">
          Loading payout…
        </div>

      </aside>

    `;


    document.body
      .appendChild(
        modal
      );


    const panel =
      modal.querySelector(
        '.pnm-panel'
      );


    await render(
      panel,
      mentorId
    );


    modal.addEventListener(
      'click',
      async event => {

        if (
          event.target.closest(
            '[data-pnm-close]'
          )
        ) {

          closeManual();
          return;

        }


        const copy =
          event.target.closest(
            '[data-pnm-copy]'
          );


        if (copy) {

          const original =
            copy.textContent;

          const ok =
            await copyText(
              copy.dataset
                .pnmCopy
            );


          copy.textContent =
            ok
              ? 'Copied ✓'
              : 'Copy failed';


          setTimeout(
            () => {

              copy.textContent =
                original;

            },
            1200
          );


          return;

        }


        const create =
          event.target.closest(
            '[data-pnm-create]'
          );


        if (create) {

          create.disabled =
            true;

          create.textContent =
            'Creating…';


          try {

            await rpc(
              'pn_admin_create_mentor_payout_batch',
              {
                p_mentor_id:
                  mentorId
              }
            );


            await render(
              panel,
              mentorId,
              'Payout batch created. Transfer this batch as one UPI payment.'
            );

          }
          catch (error) {

            await render(
              panel,
              mentorId,
              error?.message ||
              'Could not create payout batch.'
            );

          }


          return;

        }


        const cancel =
          event.target.closest(
            '[data-pnm-cancel]'
          );


        if (cancel) {

          const yes =
            window.confirm(
              'Cancel this unsubmitted payout batch? The reserved earnings will return to payable.'
            );


          if (!yes) {
            return;
          }


          cancel.disabled =
            true;


          try {

            await rpc(
              'pn_admin_cancel_unsubmitted_payout_v1',
              {
                p_payout_id:
                  cancel.dataset
                    .pnmCancel
              }
            );


            await render(
              panel,
              mentorId,
              'Payout batch cancelled. Earnings are available again.'
            );

          }
          catch (error) {

            await render(
              panel,
              mentorId,
              error?.message ||
              'Could not cancel payout.'
            );

          }


          return;

        }


        const confirm =
          event.target.closest(
            '[data-pnm-confirm]'
          );


        if (confirm) {

          const input =
            panel.querySelector(
              '[data-pnm-utr]'
            );


          const utr =
            String(
              input?.value ||
              ''
            )
              .trim();


          if (
            utr.length < 6
          ) {

            input?.focus();

            window.alert(
              'Enter the real UTR / transaction ID from the completed UPI payment.'
            );

            return;

          }


          const amount =
            Number(
              confirm.dataset
                .pnmAmount ||
              0
            );


          const yes =
            window.confirm(
              `Confirm that ${money(
                amount
              )} has actually been transferred to this mentor?`
            );


          if (!yes) {
            return;
          }


          confirm.disabled =
            true;

          confirm.textContent =
            'Confirming…';


          try {

            await rpc(
              'pn_admin_confirm_manual_payout_v1',
              {
                p_payout_id:
                  confirm.dataset
                    .pnmConfirm,

                p_utr:
                  utr
              }
            );


            await render(
              panel,
              mentorId,
              'Payout confirmed. The batch is now recorded as paid.'
            );


            setTimeout(
              () => {

                document
                  .querySelector(
                    '[data-pn5-mentor-finance-refresh]'
                  )
                  ?.click();

              },
              300
            );

          }
          catch (error) {

            window.alert(
              error?.message ||
              'Could not confirm payout.'
            );


            confirm.disabled =
              false;

            confirm.textContent =
              'Confirm payout';

          }

        }

      }
    );

  }


  /*
   * The existing Mentors drawer already has a
   * "Payout controls" button.
   *
   * Let its existing navigation move us to the
   * correct mentor finance row, then capture the
   * mentor ID and open the new manual payout UI.
   */
  document.addEventListener(
    'click',
    event => {

      const payoutControls =
        event.target.closest(
          '[data-pn5-open-payout-controls]'
        );


      if (payoutControls) {

        pendingOpen =
          true;

      }


      const mentorButton =
        event.target.closest(
          '[data-pn5-mentor-detail]'
        );


      if (mentorButton) {

        activeMentorId =
          mentorButton.dataset
            .pn5MentorDetail ||
          null;


        if (
          pendingOpen &&
          activeMentorId
        ) {

          pendingOpen =
            false;


          setTimeout(
            () => {

              hideLegacyRazorpayX();

              openManual(
                activeMentorId
              );

            },
            450
          );

        }

      }

    },
    true
  );


  window.PeerNestManualPayout = {
    open:
      openManual
  };

})();
